<span class="valor-credito">{{balance | currency | emptyValue}}</span>
<button
  aria-label="Balance" class="btn btn-sm btn-default">
  Balance
  <fa-icon [icon]="chevronDown"></fa-icon>
</button>
